export default __webpack_public_path__ + "static/media/4.900e8a35.svg";